export { Footer as default, type KindFooters } from './Footer'
